type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

export default function DashedOutlineWithInnerRectIcon({
  width = '14',
  height = '14',
  fillColor = 'white',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.36235 3.9375H4.46235C4.29991 3.9375 4.14412 4.00203 4.02925 4.1169C3.91438 4.23176 3.84985 4.38755 3.84985 4.55V9.45C3.84985 9.61244 3.91438 9.76824 4.02925 9.8831C4.14412 9.99797 4.29991 10.0625 4.46235 10.0625H9.36235C9.5248 10.0625 9.68059 9.99797 9.79546 9.8831C9.91032 9.76824 9.97485 9.61244 9.97485 9.45V4.55C9.97485 4.38755 9.91032 4.23176 9.79546 4.1169C9.68059 4.00203 9.5248 3.9375 9.36235 3.9375ZM9.36235 9.45H4.46235V8.225V7V4.55H9.36235V9.45Z"
        fill={fillColor}
      />
      <path
        d="M3.76221 9.45001V4.55035C3.76221 4.3647 3.83601 4.18645 3.96729 4.05518C4.09856 3.9239 4.27681 3.8501 4.46246 3.8501V3.93768C4.30002 3.93768 4.1441 4.00226 4.02924 4.11713L3.98865 4.16199C3.8993 4.27099 3.84979 4.40818 3.84979 4.55035V9.45001C3.84979 9.61246 3.91437 9.76837 4.02924 9.88324C4.12975 9.98376 4.26156 10.0458 4.40179 10.0597L4.46246 10.0627H9.36212C9.52457 10.0627 9.68048 9.99811 9.79535 9.88324C9.91022 9.76837 9.97479 9.61246 9.97479 9.45001V4.55035C9.97479 4.40818 9.92528 4.27099 9.83594 4.16199L9.79535 4.11713C9.68048 4.00226 9.52457 3.93768 9.36212 3.93768V3.8501C9.54777 3.8501 9.72602 3.9239 9.8573 4.05518C9.98857 4.18645 10.0624 4.3647 10.0624 4.55035V9.45001C10.0624 9.63566 9.98857 9.81392 9.8573 9.94519C9.72602 10.0765 9.54777 10.1503 9.36212 10.1503H4.46246C4.27681 10.1503 4.09856 10.0765 3.96729 9.94519C3.83601 9.81391 3.76221 9.63566 3.76221 9.45001ZM9.36212 4.55035V9.45001H4.46246V4.55035H9.36212ZM9.36212 3.8501V3.93768H4.46246V3.8501H9.36212ZM4.54962 9.36285H9.27496V4.63751H4.54962V9.36285Z"
        fill={fillColor}
      />
      <path
        d="M2.97491 9.95294V10.9373H3.95929V11.7247H2.1875V9.95294H2.97491ZM7.89679 10.9373V11.7247H5.92804V10.9373H7.89679ZM11.6373 9.95294V11.7247H9.86554V10.9373H10.8499V9.95294H11.6373ZM11.6373 6.01544V7.98419H10.8499V6.01544H11.6373ZM2.97491 6.01544V7.98419H2.1875V6.01544H2.97491ZM10.8499 3.06232H9.86554V2.2749H11.6373V4.04669H10.8499V3.06232ZM2.97491 3.06232V4.04669H2.1875V2.2749H3.95929V3.06232H2.97491ZM7.89679 2.2749V3.06232H5.92804V2.2749H7.89679Z"
        fill={fillColor}
      />
    </svg>
  );
}
